import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const CHANNELS = [
    { key: "email",  label: "Email",       hint: "Booking confirmations, cancellations, task summaries" },
    { key: "sms",    label: "SMS",         hint: "Short reminders sent via text (customer only)" },
    { key: "in_app", label: "In-app",      hint: "Notification bell inside Pearl" },
    { key: "push",   label: "Mobile push", hint: "Native mobile push (coming soon)", disabled: true },
];

/**
 * NotificationPreferences — per-user channel toggles.
 * Bound to PUT /api/notifications/preferences; loaded on mount.
 */
export default function NotificationPreferences({ testid = "notif-prefs" }) {
    const [prefs, setPrefs] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            try { setPrefs(await api.getNotificationPreferences()); }
            catch { /* ignore */ }
        })();
    }, []);

    async function toggle(key) {
        if (!prefs) return;
        const next = { ...prefs, [key]: !prefs[key] };
        setPrefs(next);
        setSaving(true);
        try {
            const saved = await api.updateNotificationPreferences({ [key]: next[key] });
            setPrefs(saved);
            toast.success("Preferences saved");
        } catch (e) {
            toast.error("Failed to save");
            // Revert
            setPrefs(prefs);
        } finally { setSaving(false); }
    }

    if (!prefs) return <div className="text-sm text-[#4B5565]">Loading…</div>;
    return (
        <div className="pe-card" data-testid={testid}>
            {CHANNELS.map((c, i) => (
                <div
                    key={c.key}
                    className={`flex items-center gap-3 px-4 py-3 ${i > 0 ? "border-t border-[#F3F4F6]" : ""}`}
                    data-testid={`${testid}-${c.key}`}
                >
                    <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium text-[#131B2F]">{c.label}</div>
                        <div className="text-xs text-[#4B5565] mt-0.5">{c.hint}</div>
                    </div>
                    <button
                        onClick={() => !c.disabled && toggle(c.key)}
                        disabled={c.disabled || saving}
                        aria-pressed={prefs[c.key]}
                        data-testid={`${testid}-toggle-${c.key}`}
                        className={`relative w-11 h-6 rounded-full transition-colors ${
                            c.disabled ? "bg-[#E5E7EB] opacity-60" :
                            prefs[c.key] ? "bg-[#3E9E2E]" : "bg-[#D1D5DB]"
                        }`}
                    >
                        <span
                            className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white transition-transform ${prefs[c.key] ? "translate-x-5" : ""}`}
                        />
                    </button>
                </div>
            ))}
        </div>
    );
}
